<template>

    <LoopItemPanel title="Slide">

        <LinkInput :options="loopItem"></LinkInput>

        <template v-slot:actionsExtra>
            <button class="btn btn-success" @click="save">
                <i class="fas fa-check mr-2"></i> Opslaan
            </button>
        </template>

    </LoopItemPanel>

</template>

<script>

import LoopItemPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/loop/owlCarousel/LoopItemPanel";
import LinkInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/LinkInput";

export default {

    extends: LoopItemPanel,

    components: {
        LoopItemPanel,
        LinkInput,
    },

    data() {
        return {
            language: 'nl',
        };
    },

    created()
    {
        this.setLanguage();
    },

    methods: {

        setLanguage() {
            this.language = document.documentElement.lang;
        },

        setWebsitePage(value) {
            // Set
            this.$set(this.options, 'websitePageId', value);
        },

    },

}
</script>
